import { render, staticRenderFns } from "./ImageRecommend.vue?vue&type=template&id=01d1ae90&scoped=true"
import script from "./ImageRecommend.vue?vue&type=script&lang=ts"
export * from "./ImageRecommend.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ImageRecommend.vue?vue&type=style&index=0&id=01d1ae90&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "01d1ae90",
  "3b1c2ea0"
  
)

export default component.exports